import React from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';
import useAuthStore from '../stores/authStore';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { LANGUAGE } from '../i18n';

const Header = () => {
  const { isAuthenticated } = useAuthStore();
  const { t } = useTranslation();

  return (
    <header className="app-header">
      <div className="app-header__content">
        <div className="app-header__logo">
          <div className="app-header__logo-icon">
            <DocumentTextIcon width={32} height={32} style={{ color: 'white' }} />
          </div>
          <div className="app-header__logo-text">
            <span className="app-header__logo-main">Legal Simplifier</span>
            {LANGUAGE === 'ru' && (
              <span className="app-header__logo-sub">by БУРАВЧИК</span>
            )}
          </div>
        </div>
        <div className="app-header__nav">
          <a 
            href={isAuthenticated ? "/documents" : "/auth"} 
            className="app-header__button"
          >
            {isAuthenticated ? t('header.myDocuments') : t('header.login')}
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header; 
